module.exports = __webpack_public_path__ + "img/3-0-0.f1f27741.png";